import type { ComponentPropsWithRef } from "react";
import Markdown from "react-markdown";
import { styled } from "styled-components";

type MarkdownAreaProps = ComponentPropsWithRef<"div"> & { children: string | null | undefined };

export const MarkdownArea = ({ children, ...rest }: MarkdownAreaProps) => (
  <Container {...rest}>
    <Markdown>{children}</Markdown>
  </Container>
);

const Container = styled.div`
  white-space: pre-line;

  a {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: none;
    transition: color 0.3s;

    &:focus-visible,
    &:hover {
      color: ${({ theme }) => theme.colors.blueDark};
    }
  }

  p,
  pre {
    margin: 0;
    white-space: pre-line;
  }

  * + p {
    margin-top: 0.8rem;
  }
`;
